import React, { useState } from 'react';
import { Gift, Coffee, Crown, Check, Heart, Star, Sparkles, X } from 'lucide-react';
import { acknowledgeGiftNotification } from '../services/firestore.js';

const GiftNotificationModal = ({ user, onClose }) => {
    const [isClosing, setIsClosing] = useState(false);

    if (!user || !user.subscriptionStatus === 'gifted') return null;

    const handleClaim = async () => {
        setIsClosing(true);
        try {
            await acknowledgeGiftNotification(user.uid);
            // Animation time
            setTimeout(() => {
                onClose();
            }, 500);
        } catch (error) {
            console.error("Error claiming gift:", error);
            setIsClosing(false);
        }
    };

    const isSuperFan = user.subscriptionTier === 'super_subscriber';
    const tierName = isSuperFan ? "Super Fan" : "Supporter";
    const accentColor = isSuperFan ? '#8b5cf6' : '#ec4899'; // Violet or Pink
    const bgGradient = isSuperFan
        ? 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(79, 70, 229, 0.2) 100%)'
        : 'linear-gradient(135deg, rgba(236, 72, 153, 0.2) 0%, rgba(244, 63, 94, 0.2) 100%)';

    const startDate = user.subscriptionStart ? new Date(user.subscriptionStart.seconds * 1000).toLocaleDateString() : 'Today';
    const endDate = user.subscriptionEnd ? new Date(user.subscriptionEnd.seconds * 1000).toLocaleDateString() : 'Unknown';

    // Perks based on tier
    const perks = isSuperFan
        ? [
            { text: "All Subscriber Emojis", icon: Check },
            { text: "Exclusive Super Fan Emojis", icon: Check },
            { text: "Super Fan Badge", icon: Star },
            { text: "Priority Support", icon: Sparkles }
        ]
        : [
            { text: "Unlock Subscriber Emojis", icon: Check },
            { text: "Supporter Badge", icon: Check },
            { text: "Warm Fuzzy Feelings", icon: Heart }
        ];

    return React.createElement('div', {
        className: 'animate-fade-in',
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.8)',
            backdropFilter: 'blur(5px)',
            zIndex: 9999, // On top of everything
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: isClosing ? 0 : 1,
            transition: 'opacity 0.5s ease'
        }
    },
        React.createElement('div', {
            className: 'glass-panel',
            style: {
                maxWidth: '500px',
                width: '90%',
                padding: '40px',
                textAlign: 'center',
                position: 'relative',
                background: '#1a1a2e',
                border: `2px solid ${accentColor}`,
                boxShadow: `0 0 50px ${accentColor}40`,
                transform: isClosing ? 'scale(0.9)' : 'scale(1)',
                transition: 'transform 0.5s ease',
                overflow: 'hidden'
            }
        },
            // Background Glows
            React.createElement('div', { style: { position: 'absolute', top: '-50%', left: '-50%', width: '200%', height: '200%', background: `radial-gradient(circle, ${accentColor}20 0%, transparent 70%)`, pointerEvents: 'none' } }),

            // Icon Header
            React.createElement('div', {
                style: {
                    width: '80px', height: '80px', borderRadius: '50%', background: bgGradient,
                    margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    border: `2px solid ${accentColor}`,
                    boxShadow: `0 0 20px ${accentColor}60`
                }
            },
                React.createElement(Gift, { size: 40, color: 'white' })
            ),

            React.createElement('h2', { style: { fontSize: '28px', marginBottom: '10px', color: 'white' } }, "You've Been Gifted!"),
            React.createElement('h3', { style: { fontSize: '20px', color: accentColor, marginBottom: '20px' } }, `${tierName} Subscription`),

            React.createElement('p', { style: { color: '#ccc', marginBottom: '30px', lineHeight: '1.6' } },
                "Someone in the community appreciates you! You've been gifted a 30-day premium subscription. Enjoy these exclusive perks:"
            ),

            // Perks List
            React.createElement('div', { style: { background: 'rgba(255,255,255,0.05)', borderRadius: '12px', padding: '20px', marginBottom: '25px', textAlign: 'left' } },
                perks.map((perk, i) =>
                    React.createElement('div', { key: i, style: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px', fontSize: '15px' } },
                        React.createElement(perk.icon, { size: 18, color: accentColor }),
                        React.createElement('span', { style: { color: 'white' } }, perk.text)
                    )
                )
            ),

            // Dates
            React.createElement('div', { style: { fontSize: '13px', color: '#999', marginBottom: '30px', display: 'flex', justifyContent: 'space-between', padding: '0 20px' } },
                React.createElement('span', {}, `Start: ${startDate}`),
                React.createElement('span', {}, `End: ${endDate}`)
            ),

            // Action Button
            React.createElement('button', {
                onClick: handleClaim,
                className: 'btn',
                style: {
                    width: '100%',
                    padding: '15px',
                    fontSize: '18px',
                    background: accentColor,
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px'
                }
            },
                React.createElement(Check, { size: 20 }), "Claim Gift"
            )
        )
    );
};

export default GiftNotificationModal;
